import React, { createContext, useContext, useState } from 'react';
import {
  IScriptureModalContextProviderProps,
  TScriptureModalContextType,
} from './types';

import ScriptureModal from './ScriptureModal';

const initialScriptureModalContext: TScriptureModalContextType = {
  showScriptureModal: (osis: string) => {},
};

export const ScriptureModalContext = createContext(
  initialScriptureModalContext
);

export const ScriptureModalContextProvider = ({
  children,
}: IScriptureModalContextProviderProps): null | JSX.Element => {
  const [osis, setOsis] = useState<string>('');
  const [isScriptureModalVisible, setIsScriptureModalVisible] =
    useState<boolean>(false);

  const showScriptureModal = (text: string) => {
    setOsis(text);
    setIsScriptureModalVisible(true);
  };

  const hideScriptureModal = () => {
    setIsScriptureModalVisible(false);
  };

  return (
    <ScriptureModalContext.Provider value={{ showScriptureModal }}>
      <>
        {children}
        <ScriptureModal
          isVisible={isScriptureModalVisible}
          onClose={hideScriptureModal}
          osis={osis}
        />
      </>
    </ScriptureModalContext.Provider>
  );
};

export const useScriptureModalContext = (): TScriptureModalContextType => {
  return useContext<TScriptureModalContextType>(ScriptureModalContext);
};
